import styled from "styled-components";

const WizardWrapper = styled.div`
  height: inherit;
  font-family: "Nunito Sans" !important;
  font-size: 14px;
`;

export default WizardWrapper;
